import { API } from "aws-amplify";
import axios from "axios";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export async function saveVideo(video: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/video`, video).then(res => res.data);
  }
  return API.post("Backend", "/video", { body: video });
}
export async function updateVideoViews(id: any) {
  // Public endpoint — use axios so unauthenticated viewers can track views
  const apiUrl = isLocalAuth ? baseURL : process.env.REACT_APP_APIURL;
  return axios.post(`${apiUrl}/video/updateViews`, id).then(res => res.data);
}
export async function updateVideoWatch(id: any) {
  // Public endpoint — use axios so unauthenticated viewers can track watches
  const apiUrl = isLocalAuth ? baseURL : process.env.REACT_APP_APIURL;
  return axios.post(`${apiUrl}/video/updateWatch`, id).then(res => res.data);
}
export async function updateEmailShare(id: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/video/updateEmailShare`, id).then(res => res.data);
  }
  return API.post("Backend", "/video/updateEmailShare", { body: id });
}
export async function updateCtaVideo(id: any) {
  // Public endpoint — use axios so unauthenticated email recipients can track CTA clicks
  const apiUrl = isLocalAuth ? baseURL : process.env.REACT_APP_APIURL;
  return axios.post(`${apiUrl}/video/update/cta`, { id }).then(res => res.data);
}
export async function sendVideoToEmail(video: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/email/send`, video).then(res => res.data);
  }
  return API.post("Backend", "/email/send", { body: video });
}
export async function getSingleTemplate(video: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/video/getTemplate`, video).then(res => res.data);
  }
  return API.post("Backend", "/video/getTemplate", { body: video });
}

export async function sendMultiEmails(video: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/email/send`, video).then(res => res.data);
  }
  return API.post("Backend", "/email/send", { body: video });
}

export async function getVideos() {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/video`).then(res => res.data);
  }
  return API.get("Backend", "/video", {});
}
export async function getVideosByUserId(queryObj: any) {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/video/user`, { params: { id: queryObj.userId, page: queryObj.page } }).then(res => res.data);
  }
  return API.get("Backend", "/video/user", {
    queryStringParameters: { id: queryObj.userId, page: queryObj.page }
  });
}
export async function getVideosByTitle(queryObj: any) {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/video/user`, {
      params: { id: queryObj.userId, page: queryObj.page, title: queryObj.title }
    }).then(res => res.data);
  }
  return API.get("Backend", "/video/user", {
    queryStringParameters: {
      id: queryObj.userId,
      page: queryObj.page,
      title: queryObj.title
    }
  });
}
export async function updateUserVideo(video: any) {
  if (isLocalAuth) {
    return axios.patch(`${baseURL}/video`, video).then(res => res.data);
  }
  return API.patch("Backend", "/video", { body: video });
}
export async function deleteVideoById(callObj: any) {
  if (isLocalAuth) {
    return axios.delete(`${baseURL}/video`, { params: { id: callObj.videoId, pageNo: callObj.pageNo } }).then(res => res.data);
  }
  return API.del("Backend", "/video", {
    queryStringParameters: { id: callObj.videoId, pageNo: callObj.pageNo }
  });
}

export async function getSingleVideo(id: string) {
  // /video/single is a public endpoint (no IAM auth) — use axios directly
  // so unauthenticated recipients can watch shared videos
  const apiUrl = isLocalAuth ? baseURL : process.env.REACT_APP_APIURL;
  return axios.get(`${apiUrl}/video/single`, { params: { id } }).then(res => res.data);
}
export async function videoCount(id: string) {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/video/count`, { params: { id } }).then(res => res.data);
  }
  return API.get("Backend", "/video/count", {
    queryStringParameters: { id: id }
  });
}
